import angular from 'angular';

function fieldName(field) {
  return field.split(':')[1];
}

function fieldWhere(field) {
  return field.split(':')[0];
}

/**
 * Splitted from metric.controller.js, to lighten it (~2800 lines before split)
 * We can probably do better when migrating in angular, for now it's not refactoring, just splitting.
 * Create could be in constructor, dependencies injection, extend abstract class, remove self, remove bind(this)...
 */
export class EnumSelector {
  // useless declarations in JS (not in TS), just to see class members at a glance
  company;
  metric;
  LocalStorageFactory;
  MetricsFactory;

  config;
  fields;
  key;
  self;

  constructor(company, metric, LocalStorageFactory, MetricsFactory) {
    this.company = company;
    this.metric = metric;
    this.LocalStorageFactory = LocalStorageFactory;
    this.MetricsFactory = MetricsFactory;
  }

  create(fields, name, items, displayedByDefault, config) {
    this.config = config;
    this.fields = fields;

    this.key = `company-${this.company.id}-metric-${this.metric.id}-field-${fields.join('-')}`;

    this.self = {
      // TODO sort alpha
      isOpen: false,
      selected: [],
      items: items.map(item => ({
        id: item.id,
        name: item.name,
        icon_name: item.type_name ? `task-icon-${item.type_name}` : item.type_name,
      })),
      changedSinceLastApply: false,
      selectionChanged: this.selectionChanged.bind(this),
      unselectAll: this.unselectAll.bind(this),
      selectAll: this.selectAll.bind(this),
      apply: this.apply.bind(this),
      name: name,
      isDisplayed: displayedByDefault,
      isMandatory: false,
      type: 'enum',
      remove: this.remove.bind(this),
      hasValue: this.hasValue.bind(this),
      selectedCriteriaForXls: this.selectedCriteriaForXls.bind(this),
      query: this.query.bind(this),
      load: this.load.bind(this),
      save: this.save.bind(this),
      loadFromReport: this.loadFromReport.bind(this),
    };
    return this.self;
  }

  remove() {
    this.self.selected = [];
  }

  hasValue() {
    return this.self.selected.length > 0;
  }

  selectedCriteriaForXls() {
    return {
      name: this.self.name,
      values: this.self.selected.map(s => {
        return { name: s.name };
      }),
    };
  }

  query() {
    let retval = {};
    let op = 'in';
    if (this.config && this.config.isBhNbh) {
      op = 'in_bh_nbh';
    } else if (this.config && this.config.timeToAnswerSurvey) {
      op = '<=';
    }
    for (let field of this.fields) {
      retval[fieldWhere(field)] = this.self.selected.map(i => [{ op: op, lvalue: fieldName(field), rvalue: i.id }]);
    }
    return retval;
  }

  load() {
    let value = this.LocalStorageFactory.getItem(this.key);
    if (value !== null) {
      this.self.selected = this.self.items.filter(i => value.findIndex(j => angular.equals(j, i.id)) !== -1);
      if (this.self.selected.length > 0) {
        this.self.isDisplayed = true;
      }
    }
  }

  loadFromReport(selectedReport, reportDate) {
    if (selectedReport) {
      let filters = [];
      Object.keys(selectedReport.filters).forEach(key => {
        filters = [...filters, ...selectedReport.filters[key]];
      });
      if (filters.length) {
        let values = [];
        filters.forEach(selector => {
          selector.forEach(clause => {
            let single_clause_value = clause[0];
            if (this.fields[0].includes(single_clause_value.lvalue)) {
              values.push(single_clause_value.rvalue);
            }
          });
        });
        this.self.selected = this.self.items.filter(i => values.findIndex(j => angular.equals(j, i.id)) !== -1);
        if (this.self.selected.length > 0) {
          this.self.isDisplayed = true; // Force visibility if a value was checked from the report criteria
        }
      }
    }
  }

  save() {
    this.LocalStorageFactory.setItem(
      this.key,
      this.self.selected.map(i => i.id)
    );
  }

  selectionChanged() {
    this.self.changedSinceLastApply = true;
  }

  apply() {
    if (this.self.changedSinceLastApply) {
      this.self.changedSinceLastApply = false;
      this.submitQuery();
    }
  }

  unselectAll() {
    this.self.selected = [];
    this.self.selectionChanged();
  }

  selectAll() {
    this.self.selected = this.self.items;
    this.self.selectionChanged();
  }

  submitQuery() {
    this.MetricsFactory.queriesWithThrottleTime$.next();
  }
}
